export * from './ng2-charts.component';